import React from 'react';
import {
  Alert,
  Box,
  Button,
  IconButton,
  Icons,
  Modal,
  Typography,
  useTheme,
} from '@ublend-npm/aulaui-core';
import {
  ASSIGNMENT_UNAVAILABLE_MESSAGE,
  ASSIGNMENT_UNAVAILABLE_TITLE,
} from './constants';
import { createStyles } from './AssignmentUnavailableModal.styles';

type Props = {
  open: boolean;
  onClose: () => void;
};

const AssignmentUnavailableModal = ({ open, onClose }: Props) => {
  const theme = useTheme();
  const styles = createStyles(theme);

  return (
    <Modal
      open={open}
      onClose={onClose}
      data-testid="assignment-unavailable-modal"
    >
      <Box sx={styles.modal}>
        <Box sx={styles.header}>
          <Typography component="h2" sx={styles.modalTitle}>
            Alert
          </Typography>
          <IconButton
            size="small"
            aria-label="Close assignment unavailable dialog"
            onClick={onClose}
          >
            <Icons.Close fontSize="medium" sx={styles.closeIcon} />
          </IconButton>
        </Box>

        <Alert severity="error" icon={<Icons.ErrorOutline />} sx={styles.alert}>
          <Typography component="span" sx={styles.alertTitle}>
            {ASSIGNMENT_UNAVAILABLE_TITLE}
          </Typography>
          <Typography component="span" sx={styles.message}>
            {ASSIGNMENT_UNAVAILABLE_MESSAGE}
          </Typography>
        </Alert>

        <Box sx={styles.actions}>
          <Button type="button" kind="primary" onClick={onClose}>
            Got it
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default AssignmentUnavailableModal;
